import React, {useEffect, useRef, useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import {getDeviceCtls, getDeviceType, getFirmwareList, postDeviceCtl} from "../../../../../api/apiClient";
import {Col, Row} from "react-bootstrap";
import RptStart from "./CtlType/RptStart";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';

function ModalTest({
                     propShow = false,
                     propDevice,
                     setShow,
                   }) {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /* 게이트웨이 제어 명령 목록 */
  const [gwCtlList, setGwCtlList] = useState([]);

  /* 게이트웨이 제어 명령 목록 갱신 */
  const updateGwCtlList = () => {
    getDeviceCtls().then(
        (res) => {
          if (res.data.data != undefined) {
            setGwCtlList(res.data.data.list);
          }
        }
    )
  };

  // 팝업 노출 시 제어 명령 목록 갱신
  useEffect(() => {
    updateGwCtlList();
    updateDeviceType();
    updateFirmwareList();
  }, []);

  useEffect(() => {
    console.log(gwCtlList);
  }, [gwCtlList])

  const onChangeCtlType = (e) => {
    e.preventDefault();
    // setType(e.target.value);
    // console.log(e.target[e.target.selectedIndex].dataset.item);
    const words = e.target[e.target.selectedIndex].dataset.item.split('|');
    console.log(words);
    setCtlType((prevState) => {
      return {...prevState, cd: e.target.value, item: words};
    });
  };

  const onChangeDeviceType = (e) => {
    console.log(e.target.value);
    setFirmSubmit({...stFirmSubmit, paramtr1: e.target.value});
  }


  const [ctlType, setCtlType] = useState({
    cd: '',
    item: '',
  });

  useEffect(() => {
    console.log(ctlType);
    setSubmit({deviceID: propDevice, ctrlTy: ctlType.cd});
  }, [ctlType]);


  // getDeviceType

  // getFirmwareList
  const refSize = useRef();
  const [stFirmList, setFirmList] = useState([]);
  const [stFirmSubmit, setFirmSubmit] = useState({
    deviceID: propDevice,
    ctrlTy: '306', // only firmware
    paramtr1: '1', // only gateway
    paramtr2: 0,
    paramtr3: 0,
  })

  useEffect(() => {
    updateFirmwareList();
  }, [stFirmSubmit]);


  const updateFirmwareList = () => {
    getFirmwareList(stFirmSubmit.paramtr1).then(res => {
      console.log(res);
      setFirmList(res.data.data.list);
    })
  }

  const onChangeFirmVersion = (e) => {
    console.log(e.target.value);
    let idx = e.target.value
    if (idx != -1) {
      refSize.current.value = stFirmList[idx].file_sz;
      setFirmSubmit({...stFirmSubmit, deviceID: propDevice,
        paramtr2: stFirmList[idx].fw_ver, paramtr3: stFirmList[idx].file_sz})
    }
    else {
      refSize.current.value = '0'
    }

  }

  /* 공통코드 목록 */
  const [deviceType, setDeviceType] = useState([]);

  /* 공통코드 목록 갱신 */
  const updateDeviceType = () => {
    getDeviceType().then(
        (res) => {
          if (res.data.data != undefined) {
            setDeviceType(res.data.data.list);
          }
        }
    )
  };

  const [stSubmit, setSubmit] = useState([]);

  const onChangeParam1 = (e) => {
    setSubmit({...stSubmit, paramtr1: e.target.value});
  }

  const onSubmit = (e) => {
    console.log(ctlType)
    if (ctlType.cd == '101') {
      console.log('sync start!')
      console.log(stSubmit);
      postDeviceCtl(stSubmit).then(res => {
        console.log(res);
		handleClose();
		Swal.fire(
			'정상적으로 처리 되었습니다!',
			'Processed successfully.',
			'success'
		);
      }).catch(err => {
		// 에러 처리
		//console.log(err.response.data.message);
		Swal.fire(
			err.response.data.message,
			'An error occurred.',
			'error'
		);
	  });
    } else if (ctlType.cd == '102') {
      console.log('sync end!')
      console.log(stSubmit);
      postDeviceCtl(stSubmit).then(res => {
        console.log(res);
		handleClose();
		Swal.fire(
			'정상적으로 처리 되었습니다!',
			'Processed successfully.',
			'success'
		);
      }).catch(err => {
		// 에러 처리
		//console.log(err.response.data.message);
		Swal.fire(
			err.response.data.message,
			'An error occurred.',
			'error'
		);
	  });
    } else if (ctlType.cd == '306') {
      console.log('update gateway firmware!')
      console.log(stFirmSubmit);
      postDeviceCtl(stFirmSubmit).then(res => {
        console.log(res);
		handleClose();
		Swal.fire(
			'정상적으로 처리 되었습니다!',
			'Processed successfully.',
			'success'
		);
      }).catch(err => {
		// 에러 처리
		//console.log(err.response.data.message);
		Swal.fire(
			err.response.data.message,
			'An error occurred.',
			'error'
		);
	  });
    }
  }


  return (
      <>
        <Modal
            show={propShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            // className={"axc-xxl-modal"}
            size="lg"
        >
          <Modal.Header closeButton closeVariant={"white"}>
            <Modal.Title>게이트웨이 제어</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Row className={"layer"}>
              <Col className={''}>
                <Row className={'info-container py-2 mx-3'}>
                  <Col md={10}>
                    <div className={'content-container-body-item'}>
                      <Form>
                        <Form.Group as={Row} controlId="formJurisdictionSelect">
                          <Form.Label column md={4} className={"label text-end"}>
                            제어명령
                          </Form.Label>
                          <Col md={8}>
                            <Form.Select
                                aria-label="Default select example"
                                className={"input input-select"}
                                onChange={onChangeCtlType}
                                defaultValue={ctlType.cd}
                            >
                              <option value={""}>제어명령 선택</option>
                              {Array.isArray(gwCtlList) ?
                                  (gwCtlList.map((elem, idx) => {
                                    return (
                                        <option key={idx} value={elem.cd} data-item={elem.item}>{elem.nm}</option>
                                    )
                                  })) : ''}
                            </Form.Select>
                          </Col>
                        </Form.Group>

                        {ctlType.cd === '101' ? (
                            <>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {ctlType.item}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input'}
                                      defaultValue={0 || 0}
                                      onChange={onChangeParam1}
                                  />
                                </Col>
                              </Form.Group>
                            </>
                        ) : ''}

                        {ctlType.cd === '102' ? (
                            <></>
                        ) : ''}

                        {ctlType.cd === '103' ? (
                            <></>
                        ) : ''}

                        {ctlType.cd === '104' ? (
                            <>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {ctlType.item}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input'}
                                      defaultValue={0 || 0}
                                  />
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  로그 출력결과
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input'}
                                  />
                                </Col>
                              </Form.Group>
                            </>
                        ) : ''}

                        {ctlType.cd === '105' ? (
                            <>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {ctlType.item}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input'}
                                      defaultValue={0 || 0}
                                  />
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  로그 출력결과
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input'}
                                  />
                                </Col>
                              </Form.Group>
                            </>
                        ) : ''}

                        {ctlType.cd === '106' ? (
                            <>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {/* WiFi활성화 */}
                                  {ctlType.item[0]}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Select
                                      aria-label="Default select example"
                                      className={"input input-select"}
                                      onChange={onChangeCtlType}
                                      defaultValue={ctlType.cd}
                                  >
                                    <option value={1}>활성(1)</option>
                                    <option value={0}>비활성(0)</option>
                                  </Form.Select>
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {ctlType.item[1]}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Select
                                      aria-label="Default select example"
                                      className={"input input-select"}
                                      onChange={onChangeCtlType}
                                      defaultValue={ctlType.cd}
                                  >
                                    <option value={1}>9 ~ 16</option>
                                  </Form.Select>
                                </Col>
                              </Form.Group>
                            </>
                        ) : ''}

                        {ctlType.cd === '306' ? (
                            <>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {/* 펌웨어타입 */}
                                  {ctlType.item[0]}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Select
                                      aria-label="Default select example"
                                      className={"input input-select"}
                                      onChange={onChangeDeviceType}
                                      defaultValue={ctlType.cd}
                                  >
                                    <option value={'-1'}>선택하세요.</option>
                                    {Array.isArray(deviceType) ?
                                        (deviceType.map((elem, idx) => {
                                          return (
                                              <option key={idx} value={elem.cd} data-item={elem.item}>{elem.nm}</option>
                                          )
                                        })) : ''}
                                  </Form.Select>
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {/* 펌웨어버전 */}
                                  {ctlType.item[1]}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Select
                                      aria-label="Default select example"
                                      className={"input input-select"}
                                      onChange={onChangeFirmVersion}
                                      defaultValue={ctlType.cd}
                                  >
                                    <option value={'-1'}>선택하세요.</option>
                                    {Array.isArray(stFirmList) ?
                                        (stFirmList.map((elem, idx) => {
                                          return (
                                              <option key={idx} value={idx}>{elem.fw_ver}</option>
                                          )
                                        })) : ''}

                                  </Form.Select>
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                                <Form.Label column md={4} className={'label text-end'}>
                                  {/* 파일 사이즈 */}
                                  {ctlType.item[2]}
                                </Form.Label>
                                <Col md={8} className={''}>
                                  <Form.Control
                                      type='text'
                                      className={'input text-white'}
                                      readOnly={true}
                                      ref={refSize}
                                      // defaultValue={stRpt.rpeat_lc_nm}
                                      // onChange={(e) => {
                                      //   onChange(e, 'rpeat_lc_nm');
                                      // }}
                                  />
                                </Col>
                              </Form.Group>
                            </>
                        ) : ''}

                      </Form>
                    </div>
                  </Col>
                </Row>

                <Row className={"my-3 justify-content-center"}>
                  <Col md={2} className={'text-center'}>
                    <Button className={'btn btn-secondary'} onClick={handleClose}>취소</Button>
                  </Col>
                  <Col md={2} className={'text-center'}>
                    <Button onClick={onSubmit} className={'btn save-btn'}>실행</Button>
                  </Col>
                </Row>

              </Col>
            </Row>

          </Modal.Body>
          {/*<Modal.Footer>*/}
          {/*  <Button variant="primary" onClick={handleClose}>*/}
          {/*    실행*/}
          {/*  </Button>*/}
          {/*  <Button variant="secondary" onClick={handleClose}>*/}
          {/*    닫기*/}
          {/*  </Button>*/}
          {/*</Modal.Footer>*/}
        </Modal>
      </>
  );
}

export default ModalTest;
